namespace Ir.Components.General.Error {
    interface IViewModel {
        
    }
    export function getViewModel(this: IViewModel, params, componentInfo) {
        
    }
}